// GENERATED FILE - DO NOT MODIFY

export enum VenueStatusDto {
    Pending = "Pending",
    Active = "Active",
    Deactivated = "Deactivated",
    Rejected = "Rejected",
}